/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used in labels.
 */
export const MONITORING_STRINGS = {
  dashboard: 'Dashboard',
  date: `Date`,
  dateAndTime: 'Date and time',
  dateRange: 'Date range',
  error: `Error`,
  experienceMonitoring: 'Experience monitoring',
  experienceMonitoringDesc: 'View your digital experience insights.',
  from: 'From',
  invalidDateParams: `Date parameters in the current URL are either incorrect or malformed, and are being ignored.`,
  logs: `Logs`,
  logsDesc: 'View activity, alerts, and errors across your tech stack.',
  message: `Message`,
  monitoring: 'Monitoring',
  noInstances: `There are no instances to display.`,
  noLogs: `There are no logs to show yet.`,
  noMatchingLogs: `There are no matching logs.`,
  pagePreview: `Page preview`,
  pageURL: 'Page URL',
  refreshLogs: `Refresh logs`,
  searchLogs: `Search logs`,
  searchTags: `Search tags`,
  selectTimeRange: `Select time range`,
  service: `Service`,
  tags: `Tags`,
  to: 'To',
  userId: `User ID`,
  userLogId: `Your user ID is `,
};
